module.exports = __webpack_public_path__ + "static/media/carrefour.7a1bbb67.png";